<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="header">Tell us about your background.</h1>
                <h2 class="subheader"></h2>
            </div>
        </div>
        <div v-if="generalErrorMessage" class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ generalErrorMessage }}
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <form @submit.prevent="submit()">
                    <div class="form-row">
                        <div class="col-md-6">
                            <b-form-group label="Race" :state="stateForField('raceId')" :invalid-feedback="errorForField('raceId')">
                                <b-form-select size="lg" @input="clearFieldError('raceId')" v-model="demographics.raceId" :state="stateForField('raceId')" :options="raceRadioOptions"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Ethnic Group" :state="stateForField('ethnicGroupId')" :invalid-feedback="errorForField('ethnicGroupId')">
                                <b-form-select size="lg" @input="clearFieldError('ethnicGroupId')" v-model="demographics.ethnicGroupId" :state="stateForField('ethnicGroupId')" :options="ethnicGroupRadioOptions"></b-form-select>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <b-form-group label="Language" :state="stateForField('languageId')" :invalid-feedback="errorForField('languageId')">
                                <b-form-select size="lg" @input="clearFieldError('languageId')" v-model="demographics.languageId" :state="stateForField('languageId')" :options="languageRadioOptions"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                        </div>
                    </div>
                    <div class="form-row">
                        <button type="submit" @click.prevent="submit()" class="btn btn-primary btn-lg mx-auto mt-2" style="width: 40%"><font-awesome-icon class="mr-2" v-show="isSaving" icon="spinner" pulse/>Next</button>
                    </div>
                </form>
            </div>
            <div class="col-xl-3"></div>
        </div>
    </div>
</template>

<script>
  import api from '../../services/api'
  import ErrorsMixin from '../../mixins/ErrorsMixin'
  import OptionsMixin from '../../mixins/OptionsMixin'
  import DemographicsMixin from '../../mixins/DemographicsMixin'
  import { BFormSelect, BFormGroup } from 'bootstrap-vue'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'DemographicsRace',

    components: { BFormGroup, BFormSelect },

    mixins: [ErrorsMixin, OptionsMixin, DemographicsMixin, AnalyticsMixin],

    data () {
      return {
        demographics: {},
        isSaving: false
      }
    },

    computed: {
      raceRadioOptions () {
        return this.optionsFromArray(this.demographics.raceOptions, 'raceId')
      },

      ethnicGroupRadioOptions () {
        return this.optionsFromArray(this.demographics.ethnicGroupOptions, 'ethnicGroupId')
      },

      languageRadioOptions () {
        return this.optionsFromArray(this.demographics.languageOptions, 'languageId')
      }

    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.demographics.raceId) {
          this.addErrorForField('raceId', 'Race is required.')
        }

        if (!this.demographics.ethnicGroupId) {
          this.addErrorForField('ethnicGroupId', 'Ethnic group is required.')
        }

        if (!this.demographics.languageId) {
          this.addErrorForField('languageId', 'Language is required.')
        }

        return !this.hasErrors()
      },

      loadData () {
        api.get('/Patient/Demographics').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)
          this.demographics = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error searching for patient: ' + error.message, error)
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
            if (error.response && error.response.data) {
              this.setErrorsFromResponse(error.response.data)
            } else if (error.message) {
              this.addErrorForField('exception', error.message)
            }
          }
        })
      },

      submit () {
        if (this.validate() !== true) {
          return
        }

        this.isSaving = true
        api.put('/Patient/Demographics', this.demographics).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)
          if (this.promptHeightWeight) {
            this.isSaving = false
            this.$router.push('/demographics-height-weight')
          } else if (this.promptAdditional) {
            this.isSaving = false
            this.$router.push('/demographics-additional')
          } else if (this.promptAdditionalPhone) {
            this.isSaving = false
            this.$router.push('/demographics-phone')
          } else {
            this.$store.setModuleStatus('Demographics', true, () => {
              this.isSaving = false
              this.$router.push(this.$store.nextRoute())
            })
          }
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error saving demographics: ' + error.message, error)
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            if (error.response && error.response.data) {
              this.setErrorsFromResponse(error.response.data)
            } else if (error.message) {
              this.addErrorForField('exception', error.message)
            }
          }
        })
      }
    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

</style>
